import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-addfeedback',
  templateUrl: './addfeedback.component.html',
  styleUrls: ['./addfeedback.component.css']
})
export class AddfeedbackComponent implements OnInit {

  //terms Values
  isaddterms: boolean = false;
  iseditterms: boolean = false;
  isdeleteterms: boolean = false;
  isviewterms: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;


  //Edit Get Values
  feedbackColl: any = [];
  feedbackid: number = 0

  feedbacktypeColl: any = [];
  mainBO: any = [];
  detColl: any = [];



  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Feedback";

  constructor(private appService: DhukanDataService, private route: ActivatedRoute, private productFindService: NgbModal, private activeModal: NgbActiveModal,
    public router: Router, private toastr: ToastrService, private loginService: LoginDataService) {
    
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {

      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {

      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {

      if (this.feedbackid > 0) {
        this.fngetFeedback();
      }


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;

    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW')
    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }




  //Get 
  fngetFeedback() {
    var data = {
      'feedbackid': this.feedbackid,


    }
    this.appService.getFeedback(data)
      .subscribe(
        (res) => {
          var result = res.json().result;

          this.mainBO = result[0][0]
          //console.log(this.mainBO)
          this.detColl = result[1]


        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }








  //Close
  //Close
  public decline() {
    this.activeModal.close(false);
  }




  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),


      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    console.log(ex)
    this.toastr.warning('Internal Error', ex);
  }





}
